import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import Tooltip from '@mui/material/Tooltip';
import { IProps as IMainProps } from './IProps';
import useDictionary from '@ui/hooks/useDictionary';

interface IProps
    extends Pick<IMainProps, 'onTemplateDownload' | 'onDevicesUpload'> {}

const Component: React.FC<IProps> = ({
    onTemplateDownload,
    onDevicesUpload,
}: IProps) => {
    const getWord = useDictionary();
    const inputRef = useRef<HTMLInputElement | null>(null);
    const upBtnRef = useRef<HTMLButtonElement | null>(null);

    return (
        <Box className="add-device__upload-bar">
            <Typography className="add-device__upload-title">
                {`${getWord('bulkAddDevices')}:`}
            </Typography>
            <Box className="add-device__upload-btn-wrap">
                <Tooltip
                    classes={{
                        popper: 'add-device__tooltip-popper',
                        tooltip: 'add-device__tooltip',
                    }}
                    title={getWord('downloadTemplate')}
                    placement="top"
                >
                    <IconButton
                        className="add-device__upload-btn"
                        onClick={onTemplateDownload}
                        onKeyDown={(e) => {
                            const { key } = e;
                            if (key === 'Enter') {
                                e.stopPropagation();
                                e.preventDefault();
                                const target = e.target as HTMLElement;
                                target.click();
                            }
                        }}
                    >
                        <DownloadIcon />
                    </IconButton>
                </Tooltip>
                <Input
                    id="devices-upload"
                    inputProps={{
                        accept: '.xlsx',
                    }}
                    onChange={onDevicesUpload}
                    sx={{ display: 'none' }}
                    type="file"
                    ref={inputRef}
                />
                <InputLabel htmlFor="devices-upload">
                    <Tooltip
                        classes={{
                            popper: 'add-device__tooltip-popper',
                            tooltip: 'add-device__tooltip',
                        }}
                        title={getWord('uploadFromFile')}
                        placement="top"
                    >
                        <IconButton
                            className="add-device__upload-btn"
                            component="span"
                            ref={upBtnRef}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (inputRef && upBtnRef.current)
                                        upBtnRef.current.click();
                                }
                            }}
                        >
                            <UploadIcon />
                        </IconButton>
                    </Tooltip>
                </InputLabel>
            </Box>
        </Box>
    );
};

const UploadDeviceComponent = React.memo(Component);

export default UploadDeviceComponent;
